import { useEffect, useState } from 'react'

export function useScrollInfo() {
  const [scrollInfo, setScrollInfo] = useState({
    atBottom: false,
    scrollPercent: 0,
    scrollY: 0,
  })

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      const docHeight = document.documentElement.scrollHeight - window.innerHeight
      const scrollPercent = docHeight > 0 ? scrollY / docHeight : 0
      const atBottom = scrollY + window.innerHeight >= document.documentElement.scrollHeight - 1

      setScrollInfo({
        atBottom,
        scrollPercent,
        scrollY,
      })
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return scrollInfo
}
